// src/features/hmis/hooks/useHMIValidation.ts
import { Validator } from 'react-admin';
import { HmiType, isValidHMIName } from '../types';

export interface UseHMIValidationResult {
  validateName: Validator;
  validateType: Validator;
  validateHotelId: Validator;
  validateZoneId: Validator;
  validateResetReason: Validator;
}

export const useHMIValidation = (): UseHMIValidationResult => {
  const validateName: Validator = (value) => {
    if (!value) return 'El nombre es requerido';
    if (typeof value !== 'string') return 'El nombre debe ser texto';
    if (!isValidHMIName(value)) {
      return 'El nombre debe tener entre 2 y 100 caracteres';
    }
    return undefined;
  };

  const validateType: Validator = (value) => {
    if (value === undefined || value === null) return 'El tipo de HMI es requerido';
    if (!Object.values(HmiType).includes(Number(value))) {
      return 'Tipo de HMI inválido';
    }
    return undefined;
  };

  const validateHotelId: Validator = (value) => {
    if (!value) return 'El hotel es requerido';
    return undefined;
  };

  const validateZoneId: Validator = (value) => {
    if (!value) return 'La zona es requerida';
    return undefined;
  };

  const validateResetReason: Validator = (value) => {
    if (!value) return 'La razón del reinicio es requerida';
    if (typeof value !== 'string') return 'La razón debe ser texto';
    if (value.length < 5) return 'La razón debe tener al menos 5 caracteres';
    if (value.length > 200) return 'La razón no puede exceder 200 caracteres';
    return undefined;
  };

  return {
    validateName,
    validateType,
    validateHotelId,
    validateZoneId,
    validateResetReason,
  };
};
